module.exports = __webpack_public_path__ + "img/Wp_2034.caa73190.png";